module.exports = __webpack_public_path__ + "img/c.0ff0d803.svg";